/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2024 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * CommonStyles
 *
 * @file CommonStyles.jsx
 * @author Manimaran S
 */

import PropTypes from 'prop-types';
import { css } from '@emotion/css';

export const BRAZE_TEMPLATE_ARROW_CLASS = 'braze-template-arrow';

export const stylesToClasses = (styleMap) => {
  const classes = {};

  Object.entries(styleMap).forEach(([key, value]) => {
    classes[key] = css({ '&&': value });
  });

  return classes;
};

const CommonStyles = (styles) => {
  const arrowColor = styles.arrowColor || 'black';

  return {
    arrowStyles: {
      [`&[x-placement*="bottom"] .${BRAZE_TEMPLATE_ARROW_CLASS}`]: {
        top: 0,
        left: 0,
        marginTop: '-0.9em',
        width: '3em',
        height: '1em',
        zIndex: 1299,
        '&::before': {
          borderWidth: '0 2em 2em 2em',
          borderColor: `transparent transparent ${arrowColor} transparent`
        }
      },
      [`&[x-placement*="top"] .${BRAZE_TEMPLATE_ARROW_CLASS}`]: {
        bottom: 0,
        left: 0,
        marginBottom: '-0.9em',
        width: '3em',
        height: '1em',
        zIndex: 1299,
        '&::before': {
          borderWidth: '2em 2em 0 2em',
          borderColor: `${arrowColor} transparent transparent transparent`
        }
      },
      [`&[x-placement*="right"] .${BRAZE_TEMPLATE_ARROW_CLASS}`]: {
        left: 0,
        marginLeft: '-0.9em',
        height: '3em',
        width: '1em',
        zIndex: 1299,
        '&::before': {
          borderWidth: '2em 2em 2em 0',
          borderColor: `transparent ${arrowColor} transparent transparent`,
          margin: '-7px !important'
        }
      },
      [`&[x-placement*="left"] .${BRAZE_TEMPLATE_ARROW_CLASS}`]: {
        right: 0,
        zIndex: 1299,
        marginRight: '-0.9em',
        height: '3em',
        width: '1em',
        '&::before': {
          borderWidth: '2em 0 2em 2em',
          borderColor: `transparent transparent transparent ${arrowColor}`
        }
      }
    }
  };
};

CommonStyles.defaultProps = {
  style: {}
};

CommonStyles.propTypes = {
  styles: PropTypes.object
};

export default CommonStyles;
